import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { stringIsAValidHttpsUrl } from '../../utils/helpers';

const IncomingWebhook = () => {
  const dispatch = useDispatch();
  const { webhook_id } = useParams();
  const { webhook, loadingUpdateIncomingWebhook, token, loadingToken } = useSelector((state) => state.general);
  const [changes, setChanges] = useState();

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'webhook',
        route: 'incomingWebhooks/getIncomingWebhookById',
        id: webhook_id,
      })
    );
  }, [dispatch, webhook_id]);

  useEffect(() => {
    if (webhook?._id) {
      setChanges({ name: webhook.name, url: webhook.url, status: webhook.status });
    }
  }, [dispatch, webhook]);

  const updateIncomingWebhook = () => {
    dispatch(generalSet({ reduxField: 'loadingUpdateIncomingWebhook', value: true }));
    dispatch(
      apiAction({
        route: 'incomingWebhooks/updateIncomingWebhook',
        reduxField: 'webhook',
        changes,
        id: webhook_id,
        setLoading: 'loadingUpdateIncomingWebhook',
      })
    );
  };

  const SaveButton = () => {
    return (
      <div data-aos='fade-up' data-aos-delay='200'>
        <button
          className='btn btn-sm btn-success'
          disabled={loadingUpdateIncomingWebhook}
          onClick={() => updateIncomingWebhook()}
        >
          Save
        </button>
      </div>
    );
  };

  console.log({ webhook, changes });
  return webhook?._id ? (
    <>
      <div>
        <Link className='btn btn-outline-dark' to='/incomingWebhooks'>
          Back to Webhooks
        </Link>
      </div>
      <div className='container mb-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
          <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0'>
            <h1>
              Webhook Details: <span className='text-primary'>{webhook.name}</span>
            </h1>
          </div>
          <div className='col-lg-12 d-flex justify-content-center pt-lg-0 border-bottom'>
            <small>
              Type: <span className='text-primary'>{webhook.whType}</span>
            </small>
          </div>
          <div className='col-lg-12 d-flex justify-content-center pt-lg-0 mt-4'>
            <small>
              Base URL: <span className='text-primary'>https://vectorapi.tech-buzz.io/webhook/{webhook.whType}</span>
            </small>
          </div>
        </div>
        <div className='row d-flex justify-content-center mt-4 pt-4 pt-lg-0'>
          <div className='col-md-6 p-3 border'>
            <span>Name</span>
            <div>
              <input
                type='text'
                className='form-control'
                defaultValue={webhook.name}
                onChange={(e) =>
                  setChanges((state) => {
                    return { ...state, name: e.target.value };
                  })
                }
              />
            </div>
            {changes?.name !== webhook.name ? <SaveButton /> : null}
          </div>
          <div className='col-md-6 p-3 border'>
            <span>Url</span>
            <div>
              <input
                type='text'
                className='form-control'
                defaultValue={webhook.url}
                onChange={(e) =>
                  setChanges((state) => {
                    return { ...state, url: e.target.value };
                  })
                }
              />
            </div>
            {changes?.url !== webhook.url && stringIsAValidHttpsUrl(changes?.url) ? <SaveButton /> : null}
          </div>
          <div className='col-md-6 p-3 border'>
            <span>Status</span>
            <div>
              <select
                type='text'
                className='form-control select'
                style={{ textAlign: 'center' }}
                defaultValue={webhook.status}
                onChange={(e) =>
                  setChanges((state) => {
                    return { ...state, status: e.target.value };
                  })
                }
              >
                <option value='ACTIVE'>ACTIVE</option>
                <option value='PAUSED'>PAUSED</option>
              </select>
            </div>
            {changes?.status !== webhook.status ? <SaveButton /> : null}
          </div>
          <div className='col-md-6 p-3 border'>
            <span>Token</span>
            {typeof token === 'string' ? (
              <div className='mt-2'>
                <h6>{token}</h6>
              </div>
            ) : (
              <div className='d-flex justify-content-center'>
                <button
                  className='btn btn-outline-dark'
                  disabled={loadingToken}
                  onClick={() => {
                    dispatch(generalSet({ reduxField: 'loadingToken', value: true }));
                    dispatch(
                      apiAction({
                        route: 'incomingWebhooks/getIncomingWebhookToken',
                        reduxField: 'token',
                        id: webhook_id,
                        setLoading: 'loadingToken',
                      })
                    );
                  }}
                >
                  Show Token
                </button>
              </div>
            )}
            {changes?.status !== webhook.status ? <SaveButton /> : null}
          </div>
        </div>
      </div>
    </>
  ) : (
    <Spinner />
  );
};

export default IncomingWebhook;
